<template>
  <Teleport to="body">
    <div
      data-testid="toast-container"
      class="fixed top-4 left-1/2 -translate-x-1/2 z-[400] flex flex-col gap-2 pointer-events-none"
      role="region"
      aria-label="Notifications"
    >
      <TransitionGroup name="toast" tag="div" class="flex flex-col gap-2">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          :data-testid="`toast-${toast.type}`"
          class="pointer-events-auto min-w-[280px] max-w-md px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 text-white"
          :class="typeClasses[toast.type]"
          role="status"
          aria-live="polite"
        >
          <span class="text-xl" aria-hidden="true">{{ icons[toast.type] }}</span>
          <span class="flex-1 text-elderly-base">{{ toast.message }}</span>
          <button
            type="button"
            class="text-white/80 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white rounded"
            :aria-label="$t('common.close')"
            @click="remove(toast.id)"
          >
            ✕
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { toasts, remove } = useToast()

const typeClasses: Record<string, string> = {
  success: 'bg-green-600 dark:bg-green-700',
  error: 'bg-red-600 dark:bg-red-700',
  warning: 'bg-amber-500 dark:bg-amber-600',
  info: 'bg-blue-600 dark:bg-blue-700',
}

const icons: Record<string, string> = {
  success: '✅',
  error: '❌',
  warning: '⚠️',
  info: 'ℹ️',
}
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
